import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  uuid: '',   //商品详情页面的uuid
  center: 0,//锦泉要的center
  sale_price:'',//鞋子的售价
  is_Edit:false,//是否制作了鞋子
  product_id:'',//产品ID
  // product_name:'',//产品名称
  // product_tag:'',//产品标签
  ftdconfir:false,//是否确认脚型数据
  explaincon:false,//商品详情页的《定制说明》
  explain:false,//提交订单页的《定制说明》
  agree_explain:false,//提交订单页的同意勾选框
  customized:{},//定制参数
  // base_image:'',//线装图
  whiteimage:'',//线装图辅助图
  // merge_img:'',//定制帮面图数组
  passport:false,//足型报告弹出层
  custom:[],//定制参数，，，
  hasdefautaddress:false,//是否有默认地址
  defautaddress:false,//默认地址
  comfirmpass:false,//是否确认脚型数据（从接口返回的）
  business_shoes_size: null,  // 下单页 用户编辑穿鞋尺码
  shoes_preference: null,   // 下单页 用户编辑穿鞋偏好
  preference_desc: null,    // 下单页 用户编辑穿鞋痛点




  /* 锦泉 */
  passportlistenteruuid: '',
  itemcenter: 0,
  address: {},
  centeraddress: 0,
  choisaddress: false,
  coupon: '',
  coupons: [],
  choiscoupon: false, // 是否选择了券
  ischangecoupon: false, // 是否修改了优惠券
  commoditydetailurl: null,
  tomap: false,
  istomap: 0,
  istomap2: 0,
  hasaddress: true,
  tomapstate: false,
  selectcoupon: {}, // coupon.vue里存放选中的优惠券
  orderamount: null,
  newchoiscoupon: [],//选中的劵
  couponprise: null,//折后价
  newaddress: false, // 是否是新增地址
  setA: false, // 阻止新增地址的第二次回退
  isDoubt: false, //
  editrefresh: false, // 編輯地址時是否刷新
  product_id: '', // tata.coupon需要的商品id
  showbuttom: false, // 首页product_index.vue是否显示页面下半部分
  storeforload: false, // 路由跳转是的动画开启与否
  comSelecParameters: {
    base_image:'',//线装图
    product_name:'',//产品名称
    product_tag:'',//产品标签
    bnintrodarrvalue: '',//宽窄版的选择值key
    size_pool_num: '', //宽窄版选择的尺码
    modeissize: 0, // 类型1是在店定制0为高端定制
  }, // 商品详情中选取的除custom这个数组外的商品参数
  detailApiDetails: null, // activity的值
  articleApiDetails: null, // article的值
  getticketApiDetails: null, // getticket的值
  toListRouter: null, // productlist的路由
  exclusiveItem: null, // 从商品推荐进入的商品详情的选中值
  recommendScore: 0, // 从商品推荐进入的商品评分
  // includedComponents: "productlist", // 要缓存的组件名，空为都缓存
  includedComponents: ['productindexnull','productlist','search','listSearch'], // 要缓存的组件名，空为都缓存
  excludedComponents: [], // 不缓存的组件名，空为都不缓存
  couponReceiveShowName: '', // 转赠优惠券时需要的券名
  couponReceiveParValue: '', // 转赠优惠券时需要的面值
  showreceive: false, // 商品详情优惠券领取部分是否打开
  openpurchase: false, // 商品详情商品信息部分是否打开
  detailCouponScrollT: 0, // 商品详情优惠券领取部分页面滚动距离
  showToCouponType: false, // 是否展示选择定价或不定价的入口

  /*zhaoyinfa*/
  loginfirst:true,
  islogin:0,
  shopname:"意礴定制商城",
  referer:"",
  sex:"",
  categoryId:"",
  tagId:"",
  num:"",
  linkway:"",
  // saleservice
  applyreason:"",
  saleserviceimg:[],
  //监听首页滑动到什么地方
  scrollx:0,
  scrolly:0,
  // 是否显示弹框
  popupwindow:true,

  scrolltoplisttodetail: 0, // 列表跳转商品详情时存下页面滚动距离
  xx: 0, // 列表跳转商品详情时存下页面滚动距离
  searchClassificationConfCate: {}, // 首页搜索的常用分类1男2女
  includedComponentsSearch: ['search'], // search页面要缓存的组件名，空为都缓存
  excludedComponentsSearch: [], // search页面不缓存的组件名，空为都不缓存
  // showSearch: false, // 搜索页是否出现
  useDiscountType: 0, // 确认订单时是否使用活动价，1是0否
  transmitInformationParms: {}, // 记录页面信息要传的参数
  normalPay: null, // 记录页面信息时支付过程，限定为1才记录，防止后退又前进的操作
}

export default new Vuex.Store({
  state
})



// WEBPACK FOOTER //
// ./src/vuex/state.js